import Model from "../../Model.js";

/**
 * `periodReportDefaultText` contains a piece of html text that can be added to comments.
 *
 * @param {string} spec.id - Id of the model.
 * @param {string} spec.label - Label to display for identification purposes.
 * @param {string} spec.content - HTML string content of the text.
 */
export default class PeriodReportDefaultText extends Model {
	constructor({ id, label, content } = {}) {
		super(...arguments);
		this._id = id;
		this._label = label;
		this._content = content;
	}

	getId() {
		return this._id;
	}

	getLabel() {
		return this._label || "";
	}

	setLabel(label) {
		this._label = label;
	}

	getContent() {
		return this._content;
	}

	setContent(content) {
		this._content = content;
	}

	_getMatchingFields() {
		return [this._label, this._content];
	}

	_serializedProperties() {
		const schema = super._serializedProperties();

		schema.id = this._id;
		schema.label = this._label;
		schema.content = this._content;

		return schema;
	}
}
